import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", ...a }, /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("style", null, ".amenitiz_svg__cls-2{fill:#000076}")), /* @__PURE__ */ e.createElement("g", { id: "amenitiz_svg__Layer_2", "data-name": "Layer 2" }, /* @__PURE__ */ e.createElement("g", { id: "amenitiz_svg__Layer_1-2", "data-name": "Layer 1" }, /* @__PURE__ */ e.createElement("g", { id: "amenitiz_svg__Amenitiz-Icon-Color" }, /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h48v48H0z" }), /* @__PURE__ */ e.createElement(
  "path",
  {
    d: "M18.93 29.23l6-13.06L30 27.88h6.09L25.52 4.34a.58.58 0 00-1.05 0L6 44h6.24l4.28-9.33z",
    className: "amenitiz_svg__cls-2"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    d: "M32.6 38.49h8.16L43.27 44H24.83l4.61-9.49H18.12l2.31-5.33h15.75a.5.5 0 01.45.71z",
    className: "amenitiz_svg__cls-2"
  }
)))));
export {
  t as default
};
